import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";

interface Props {
	tagList: string[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const TravelDaysComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const evNightListData = dataStr.replaceAll("|", "").split("^");

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="evNightList0"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={"전체"}
				/>
				<label htmlFor="evNightList0">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{evNightListData.map((value, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`evNightList${idx + 1}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.includes(value)}
						value={value}
					/>
					<label htmlFor={`evNightList${idx + 1}`}>
						<span>{value}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const TravelDays = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter TravelDays Error">
		<TravelDaysComponent {...props} />
	</ErrorBoundary>
);

export default TravelDays;
